import { render, staticRenderFns } from "./add-section-carousel.vue?vue&type=template&id=7e88e287&scoped=true&"
import script from "./add-section-carousel.vue?vue&type=script&lang=js&"
export * from "./add-section-carousel.vue?vue&type=script&lang=js&"
import style0 from "./add-section-carousel.vue?vue&type=style&index=0&id=7e88e287&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e88e287",
  null
  
)

export default component.exports